module.exports = __webpack_public_path__ + "img/boiler-service.162960da.webp";